import { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import styles from "./EntryDetailPage.module.css";
import closebutton from "../../assests/closebutton.svg";
import backButton from "../../assests/popup/backButton.svg";
import shareButton from "../../assests/shareWithoutBg.svg";
import loadingAnimation from "../../assests/loading.json";
import Right from "../../assests/popup/ryt.svg";
import Left from "../../assests/popup/lftw.svg";
import ScrollDown from "../../assests/ScrollDownWhite.svg";
import { useLocation, useNavigate, useParams } from "react-router";
import trophy from "../../assests/trophy.png";
import vsIcon from "../../assests/vsIcon.svg";
import * as _ from "lodash";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import prediction from "../../assests/Prediction.png";
import Like from "../../../src/assests/likedWithoutBg.svg";
import BlacLike from "../../../src/assests/likeWithoutBg.svg";
import Loading from "../../../src/assests/loading.gif";
import Share from "../../../src/assests/ShareNow.svg";
import SharePopup from "../SharePopup/SharePopup";
import { click } from "@testing-library/user-event/dist/click";
import { ViewReporter } from "../../context/apiCalls/apiCalls";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import singinLogo from "../../assests/signIn.png";
import user from "../../assests/user.svg";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Lottie from "react-lottie-player";
import Certificate from "../../assests/svg/Certificate";
import FullScreenIcon from "../../assests/svg/FullScreenIcon";
import FullScreenViewer from "../FullScreenViewer/FullScreenViewer";
import AudioPlayerWithoutDownload from "../AudioPlayerWithoutDownload/AudioPlayerWithoutDownload";
import usePageImageGalleryScroll from "../../hooks/usePageImageGalleryScroll";
import LikePopup from "../LikePopup/LikePopup";
import axios from "axios";
import FloatingWidgets from "../FloatingWidgets/FloatingWidgets";
import WhatsappNumberVerfication from "../WhatsappNumberVerfication/WhatsappNumberVerfication";
import EmailVerification from "../EmailVerification/EmailVerification";
import WhatsappLike from "../WhatsappLike/WhatsappLike";
import { createSearchParams } from "react-router-dom";
import MessagePopup from "../MessagePopup/MessagePopup";
let cancelTokenSource = null;

const EntryDetailPage = () => {
  const {
    clickedImg,
    setClickedImg,
    details,
    campaignMetaData,
    likeMap,
    setLikeMap,
    campaignClosed,
    pageNumber,
    setPageNumber,
    viewMore,
    setViewMore,
    setContestImageGalleryContents,
    buildType,
    isMobile,
    setReportErrorPopup,
  } = useContext(Context);
  const {
    currentUser,
    userIdToken,
    guestModeEnabled,
    setPreviousLocation,
    userDetailsFromApi,
    whatsappVerified,
    setVerificationPopup,
    verificationPopup,
    fetchUserData,
    emailVerified,
    setEmailPopup,
    emailPopup,
    searchParams,
    newUserId,
  } = useUserAuth();
  const { contestUniqueText, index } = useParams();
  let currentIndex = parseInt(index);
  const [share, setShare] = useState(false);
  const [profilePicture, setProfilePicture] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [whatsappLikePopup, setWhatsappLikePopup] = useState(false);
  const [showFullScreen, setShowFullScreen] = useState(false);
  const [likePopup, setLikePopup] = useState(false);
  const [likeMessage, setLikeMessage] = useState("");
  const [likesAndViewOfUser, setLikesAndViewOfUser] = useState({});
  const [isViewed, setisViewed] = useState(false);
  const [likeMapObjApi, setLikeMapObjApi] = useState({});
  const [initialRender, setInitialRender] = useState(true);
  const [loginConfirmation, setLoginConfirmation] = useState({});
  var contestDetails =
    details &&
    details.contests &&
    details.contests.find((el) => {
      return el?.contestUniqueText === contestUniqueText;
    });

  let organiserId = contestDetails && contestDetails?.orgId;
  let campaignId = contestDetails && contestDetails?.campaignId;
  let contestId = contestDetails && contestDetails?.contestId;
  const userId = localStorage.getItem("userId");
  let userIdFromLocalOrApi = newUserId || userId;
  const token = userIdToken || currentUser?.accessToken;
  const [contestClosed, setContestClosed] = useState(false);
  const contestStatus = contestDetails?.contestStatus;
  const organizerName_fromURL = window.location.href
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const campaignName_fromURL = window.location.href
    .split("/")[4]
    ?.replace(/\.html$/, "");
  const contest_fromURL = window.location.href
    .split("/")[5]
    ?.replace(/\.html$/, "");
  useEffect(() => {
    if (contestStatus === "CLOSED") {
      setContestClosed(true);
    }
  }, [contestStatus]);
  useEffect(() => {
    if (organiserId && campaignId && contestId) {
      likeChecker();
    }
  }, [organiserId, campaignId, contestId]);
  useEffect(() => {
    const updatedLikeMap = new Map(likeMap);
    const likedEntryObject = likeMapObjApi;
    if (likedEntryObject) {
      Object?.entries(likedEntryObject)?.forEach(([key, value]) => {
        if (updatedLikeMap.has(key)) {
          const obj = { ...updatedLikeMap.get(key), ...value };

          updatedLikeMap.set(key, obj);
        } else {
          updatedLikeMap.set(key, value);
        }
      });

      setLikeMap(updatedLikeMap);
    }
  }, [likeMapObjApi]);

  const { dataloading, error, contestImageGalleryContents, hasMore } =
    usePageImageGalleryScroll(
      pageNumber,
      token,
      campaignId,
      contestId,
      organiserId,
      guestModeEnabled,
      campaignMetaData,
      viewMore,
      likeMap,
      setLikeMap,
      initialRender,
      setInitialRender,
      contestDetails
    );
  function ShareHandle() {
    if (isMobile) {
      let copyText = "";
      if (userIdFromLocalOrApi) {
        copyText =
          "https://share.goviralit.com" +
          "/vidu" +
          userIdFromLocalOrApi +
          "o" +
          clickedImg?.orgId +
          "cp" +
          clickedImg?.campaignId +
          "cn" +
          clickedImg?.contestId +
          "e" +
          clickedImg?._id;
      } else {
        copyText =
          "https://share.goviralit.com" +
          "/vid" +
          "o" +
          clickedImg?.orgId +
          "cp" +
          clickedImg?.campaignId +
          "cn" +
          clickedImg?.contestId +
          "e" +
          clickedImg?._id;
      }
      if (window.messageHandler) {
        window.messageHandler.postMessage(
          JSON.stringify({
            url: copyText,
            imageUrl: clickedImg?.qrCodeUrl,
          })
        );
      } else {
        alert("Flutter messageHandler not found!");
      }
      return;
    }
    setShare(share ? false : true);
  }
  useEffect(() => {
    if (location?.state?.viewMore) {
      if (!guestModeEnabled) {
        setViewMore(true);
      }
    }
  }, [currentIndex]);
  console.log("whatsappVerified", whatsappVerified);

  useEffect(() => {
    const likeAfterLogin = async () => {
      const popupData = contestImageGalleryContents?.filter((item) => {
        return (
          contestImageGalleryContents?.indexOf(item) === location?.state?.index
        );
      });
      const newItem = popupData[0];
      setClickedImg(newItem);
      if (
        location?.state?.like &&
        likeMap.has(location?.state?.id) &&
        !loading
      ) {
        if (!whatsappVerified && details?.likeType !== "NORMAL") {
          setVerificationPopup(true);
          return;
        }
        if (
          emailVerified == false &&
          details?.likeType == "NORMAL" &&
          details?.closedCampaign
        ) {
          // const userData = await fetchUserData();
          // if (userData?.emailVerified == false) {
          //   setEmailPopup(true);
          //   return;
          // }
          setEmailPopup(true);
          return;
        }
        handleLike(
          location?.state?.request,
          location?.state?.id,
          location?.state?.index,
          "signup"
        );
        let updatedState = { ...location?.state, like: false };
        navigate(null, { replace: true, state: updatedState });
      }
    };
    if (location?.state?.like) {
      likeAfterLogin();
    }
  }, [likeMap, whatsappVerified]);
  useEffect(() => {
    if (_.isEmpty(clickedImg)) {
      setClickedImg(
        contestImageGalleryContents && contestImageGalleryContents[currentIndex]
      );
    }
  }, [contestImageGalleryContents]);
  const likeChecker = async () => {
    setLoading(true);
    try {
      let config = {
        method: "GET",
        url: `${process.env.REACT_APP_LIKECHECK}/${organiserId}/${campaignId}/${contestId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);
      setLikesAndViewOfUser(response?.data?.result);
      setLikeMapObjApi(response?.data?.result);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleLike = async (isLike, mapId, index, source) => {
    const updatedLikeMap = new Map(likeMap);
    let likeObj = updatedLikeMap.get(mapId);
    let phone = userDetailsFromApi?.phoneNumber;
    let regions = "";
    let verified = false;
    if (!_.isEmpty(details?.likeAllowedCountries) && phone) {
      details?.likeAllowedCountries?.forEach((element, i) => {
        if (phone?.startsWith(element?.code)) {
          verified = true;
        }
        regions += element?.country;
        if (i < details?.likeAllowedCountries.length - 1) {
          regions += ", ";
        }
      });
      if (!verified) {
        setLikePopup(true);
        setLikeMessage(
          `Votes for this contest are limited to mobile numbers under the region(s) - "${regions}"`
        );
        return;
      }
    }
    if (
      contestDetails?.likeClosed ||
      new Date() > new Date(contestDetails?.judgementCompleteDate)
    ) {
      setLikeMessage(
        `Unfortunately, we are unable to accept any more votes at this time as the contest has officially concluded.`
      );
      setLikePopup(true);
    } else {
      if (isLike) {
        const likeType = details?.likeType || "";
        if (
          !whatsappVerified &&
          !(likeType == "NORMAL" || likeType == "CORPORATE")
        ) {
          setVerificationPopup(true);
          navigate(null, {
            state: {
              like: true,
              request: !likeMap.get("con" + clickedImg?._id)?.liked,
              id: "con" + clickedImg?._id,
              previousLocation: location?.pathname,
              index: currentIndex,
            },
          });
          return;
        }
        if (source == "signup") {
          if (!likeObj.liked) likeObj.likesCount = likeObj?.likesCount + 1;
        } else {
          likeObj.likesCount = likeObj?.likesCount + 1;
        }
        likeObj.liked = isLike;
        updatedLikeMap.set(mapId, likeObj);
        setLikeMap(updatedLikeMap);
        let idToCheck = "con" + clickedImg?._id;
        await likeOrDislike(clickedImg, isLike);
      } else {
        setLikeMessage(`You've already voted for this post. 
Thank you for your support!`);
        setLikePopup(true);
      }
    }
  };
  const likeOrDislike = async (item, isLike) => {
    const campaignId = item?.campaignId;
    const contestId = item?.contestId;
    const videoId = item?._id;
    let url = "";
    const likeType = details?.likeType || "";
    const uniqueId =
      userDetailsFromApi?.uniqueId || localStorage?.getItem("uniqueId");
    if (isLike === true) {
      url = `${process.env.REACT_APP_LIKE}/${organiserId}/${campaignId}/${contestId}/${videoId}?command=like&type=${likeType}&uniqueId=${uniqueId}`;
    } else {
      // url = `${process.env.REACT_APP_LIKE}/${organiserId}/${campaignId}/${contestId}/${videoId}?command=disLike`;
      url = `${process.env.REACT_APP_LIKE}/${organiserId}/${campaignId}/${contestId}/${videoId}?command=like&type=${likeType}&uniqueId=${uniqueId}`;
    }
    // setLoading(true);
    // Cancel the previous request (if any)
    if (cancelTokenSource !== null) {
      cancelTokenSource.cancel("Request canceled due to button click.");
    }

    // Create a new cancel token source

    cancelTokenSource = axios.CancelToken.source();
    try {
      let config = {
        method: "post",
        url: url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        cancelToken: cancelTokenSource.token,
      };
      const response = await axios(config);
      // setLike(!item.isLiked);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
      } else {
        console.log("Error:", error.message);
      }
    }
  };
  const requestGeolocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation not supported"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position.coords); // Resolve with coords
        },
        (error) => {
          let errorMessage = "";
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = `Location access denied.\n To enable location, please go to your device settings, find this website, and allow location access. `;
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = "Location information is unavailable.";
              break;
            case error.TIMEOUT:
              errorMessage = "The request to get user location timed out.";
              break;
            default:
              errorMessage = "An unknown error occurred.";
              break;
          }
          reject(new Error(errorMessage)); // Reject with error message
        },
        { enableHighAccuracy: true, maximumAge: 0 }
      );
    });
  };

  function haversineDistance(lat1, lon1, lat2, lon2) {
    const toRadians = (angle) => (angle * Math.PI) / 180; // Convert degrees to radians
    const R = 6371000; // Radius of Earth in meters

    const dLat = toRadians(lat2 - lat1); // Change in latitude
    const dLon = toRadians(lon2 - lon1); // Change in longitude

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); // Calculate the central angle
    return R * c; // Return the distance in meters
  }

  function isLocationWithinRadius(userLat, userLon, targetLat, targetLon) {
    const distance = haversineDistance(userLat, userLon, targetLat, targetLon);

    return distance;
  }

  async function LikeHandle() {
    if (!contestDetails?.likeClosed) {
      if (guestModeEnabled) {
        if (likeMap.get("con" + clickedImg?._id)?.liked) {
          setLikeMessage(`You've already voted for this post. 
          Thank you for your support!`);
          setLikePopup(true);
          return;
        }
        let phone = userDetailsFromApi?.phoneNumber;
        let regions = "";
        let verified = false;
        if (!_.isEmpty(details?.likeAllowedCountries) && phone) {
          details?.likeAllowedCountries?.forEach((element, i) => {
            if (phone?.startsWith(element?.code)) {
              verified = true;
            }
            regions += element?.country;
            if (i < details?.likeAllowedCountries.length - 1) {
              regions += ", ";
            }
          });
          if (!verified) {
            setLikePopup(true);
            setLikeMessage(
              `Votes for this contest are limited to mobile numbers under the region(s) - "${regions}"`
            );
            return;
          }
        }
        if (!_.isEmpty(details?.likeLatLong)) {
          try {
            const { latitude, longitude, accuracy } =
              await requestGeolocation();
            const targetLatLong = details?.likeLatLong;
            const targetDistance = targetLatLong?.radius + accuracy;
            const distance = isLocationWithinRadius(
              latitude,
              longitude,
              targetLatLong?.latitude,
              targetLatLong?.longitude,
              targetLatLong?.radius + accuracy
            );
            if (distance > targetDistance) {
              setLikePopup(true);
              setLikeMessage(
                `This contest's voting is limited to a ${
                  targetLatLong?.radius / 1000
                } Kilometer radius. You are currently ${Math.round(
                  distance / 1000
                )} Kilometers away`
              );
              return;
            }
          } catch (error) {
            setLikePopup(true);
            setLikeMessage(error?.message);
            return;
          }
        }
        if (isMobile) {
          setPreviousLocation(window.location.pathname);
          navigate(`/signup`, {
            state: {
              like: true,
              request: !likeMap.get("con" + clickedImg?._id)?.liked,
              id: "con" + clickedImg?._id,
              previousLocation: location?.pathname,
              index: currentIndex,
            },
          });
          return;
        }
        setWhatsappLikePopup(true);
        // setPreviousLocation(window.location.pathname);
        // navigate(`/signup`, {
        //   state: {
        //     like: true,
        //     request: !likeMap.get("con" + clickedImg?._id)?.liked,
        //     id: "con" + clickedImg?._id,
        //     previousLocation: location?.pathname,
        //     index: currentIndex,
        //   },
        // });
      } else {
        if (
          emailVerified == false &&
          details?.likeType == "NORMAL" &&
          details?.closedCampaign
        ) {
          // const userData = await fetchUserData();
          // if (userData?.emailVerified == false) {
          //   setEmailPopup(true);
          //   return;
          // }
          setEmailPopup(true);
          return;
        }
        handleLike(
          !likeMap.get("con" + clickedImg?._id)?.liked,
          "con" + clickedImg?._id,
          currentIndex
        );
      }
    }
  }
  // const { profilePicture } = useGetUserProfileImage(clickedImg);
  useEffect(() => {
    let url = `https://storage.googleapis.com/goviralprofiledatas/${clickedImg?.uid}`;
    setProfilePicture(url);
  }, [clickedImg]);

  const profileHelpNavigate = () => {
    window.open(`/profile/help`);
  };
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
  }, [clickedImg]);
  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleOpenCertificate = () => {
    let certificateLink = "";
    if (buildType == "highonevent") {
      certificateLink = `https://share.highonevent.com/certu${clickedImg?.userId}o${clickedImg?.orgId}cp${clickedImg?.campaignId}cn${clickedImg?.contestId}e${clickedImg?._id}`;
    } else {
      certificateLink = `https://share.goviralit.com/certu${clickedImg?.userId}o${clickedImg?.orgId}cp${clickedImg?.campaignId}cn${clickedImg?.contestId}e${clickedImg?._id}`;
    }
    window.open(certificateLink, "_blank");
  };

  const handleViewLike = (e) => {
    if (clickedImg?.uid == currentUser?.uid) {
      e.stopPropagation();
      navigate(
        {
          pathname: `/${clickedImg?.orgDomain}/${clickedImg?.campaignUniqueText}/${clickedImg?.contestUniqueText}/${clickedImg?._id}/likes`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        { state: { previousLocation: location?.pathname } }
      );
    }
  };
  const initializeView = (item) => {
    let idToCheck = "con" + item?._id;

    if (
      likesAndViewOfUser[idToCheck] === undefined &&
      !_.isEmpty(likesAndViewOfUser)
    ) {
      setLikesAndViewOfUser({
        ...likesAndViewOfUser,
        [idToCheck]: { liked: false, viewed: false },
      });
      setisViewed(false);
    } else {
      if (likesAndViewOfUser[idToCheck]?.viewed) {
        setisViewed(true);
      } else {
        setisViewed(false);
      }
    }
  };

  useEffect(() => {
    if (!guestModeEnabled) {
      let idToCheck = "con" + clickedImg?._id;

      if (!isViewed && !loading) {
        if (!_.isEmpty(likesAndViewOfUser)) {
          clickedImg.viewsCount += 1;
          likesAndViewOfUser[idToCheck].viewed = true;
        } else {
          clickedImg.viewsCount += 1;
          setLikesAndViewOfUser({
            ...likesAndViewOfUser,
            [idToCheck]: { viewed: true },
          });
        }
        ViewReporter(
          clickedImg.campaignId,
          clickedImg.contestId,
          clickedImg._id,
          token,
          clickedImg.orgId
        );
      }
    }
  }, [currentIndex, isViewed]);
  const handleSignIn = () => {
    navigate(
      {
        pathname: `/signup`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      {
        state: {
          previousLocation: location?.pathname,
          viewMore: true,
          index: currentIndex,
        },
      }
    );
  };
  const handelRotationRight = () => {
    const totalLength = contestImageGalleryContents?.length;
    const limit = contestDetails?.entriesToDisplay || 48;

    if (currentIndex + 1 == limit) {
      if (guestModeEnabled) {
        setPreviousLocation(window.location.pathname);
        setLoginConfirmation({
          error: "Sign in to View more",
          description:
            "Sign in to see more entries from people who participated in this contest.",
        });
      }
    } else if (currentIndex + 1 >= limit - 3 && currentIndex + 1 <= limit) {
      if (!guestModeEnabled) {
        setViewMore(true);
      }
    }
    if (currentIndex + 3 >= totalLength) {
      if (hasMore && !dataloading) {
        setPageNumber(pageNumber + 1);
      }
    }
    let newIndex = currentIndex + 1;
    if (newIndex === totalLength) {
      newIndex = currentIndex;
    }
    const newUrl = contestImageGalleryContents?.filter((item) => {
      return contestImageGalleryContents?.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0];
    if (guestModeEnabled === false) {
      initializeView(newItem);
    }
    setClickedImg(newItem);
    if (currentIndex + 1 == limit) {
      if (!guestModeEnabled) {
        navigate({
          pathname: `/${organizerName_fromURL}/${campaignName_fromURL}/${contest_fromURL}/${newIndex}`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      }
    } else {
      navigate({
        pathname: `/${organizerName_fromURL}/${campaignName_fromURL}/${contest_fromURL}/${newIndex}`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };

  const handelRotationLeft = () => {
    const totalLength = contestImageGalleryContents?.length;
    if (currentIndex === 0) {
      const newUrl =
        contestImageGalleryContents &&
        contestImageGalleryContents[totalLength - 1];
      setClickedImg(newUrl);
      return;
    }
    const newIndex = currentIndex - 1;
    const newUrl = contestImageGalleryContents?.filter((item) => {
      return contestImageGalleryContents?.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0];
    if (guestModeEnabled === false) {
      // initializeLike(newItem);
      initializeView(newItem);
    }
    setClickedImg(newItem);
    navigate({
      pathname: `/${organizerName_fromURL}/${campaignName_fromURL}/${contest_fromURL}/${newIndex}`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };

  const handleClick = () => {
    // setContestImageGalleryContents([]);
    if (viewMore) {
      setPageNumber((prevState) => prevState + 1);
    }
    // setViewMore(false);
    navigate({
      pathname: `/${organizerName_fromURL}/${campaignName_fromURL}/${contest_fromURL}`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };
  useEffect(() => {
    if (_.isEmpty(clickedImg)) {
      handleClick();
    }
  }, []);
  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled =
    currentIndex === contestImageGalleryContents?.length - 1 && !hasMore;
  return (
    <>
      {emailPopup && <EmailVerification setPopup={setEmailPopup} />}
      {!_.isEmpty(loginConfirmation) && (
        <MessagePopup
          logo={singinLogo}
          setPopup={setLoginConfirmation}
          backgroundColor={contestDetails?.buttonColor}
          message={loginConfirmation?.description}
          action={handleSignIn}
        />
      )}
      {whatsappLikePopup && (
        <WhatsappLike
          entry={clickedImg}
          setPopup={setWhatsappLikePopup}
          type="vote"
        />
      )}
      {verificationPopup && (
        <WhatsappLike
          entry={clickedImg}
          setPopup={setVerificationPopup}
          type="verification"
        />
      )}
      <FloatingWidgets
        page="entry"
        prize={details?.priceDescription}
        endTime={details?.endDate}
        color={details?.btnColor}
        bgColor={details?.bgColor}
      />
      <div className={` dismiss z-[100] max-w-[425px] mx-auto`}>
        <div
          className={`h-[100%] w-[100%] max-w-[425px] bg-[#000000] relative min-h-[100vh]`}
        >
          <div className={styles.header}>
            <div className={styles.headerInnerPill} onClick={handleClick}>
              <img
                src={backButton}
                alt=""
                className={` dismissButton ${styles.backButton}`}
              />
              <div className="z-[1]">
                <p className="text-regular text_1Line ">
                  {/* {contestDetails?.campaignName}
              {" - "} */}
                  <span style={{ color: contestDetails?.buttonColor }}>
                    {" "}
                    {contestDetails?.contestName}
                  </span>
                </p>
              </div>
              <div className="w-[32px] h-[32px]" />
            </div>
          </div>

          {contestDetails?.contestType !== "REVIEW" && (
            <div className="flex justify-between items-center   w-[100%] gap-[15px] py-[16px] px-[20px]">
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center justify-center gap-[10px] select-none z-[1]">
                  <img
                    src={profilePicture ? profilePicture : user}
                    alt=""
                    className="h-[40px] w-[40px] rounded-full overflow-hidden  object-cover"
                    onError={() => setProfilePicture("")}
                  />

                  <p className="text-regular">{clickedImg?.participantName}</p>
                </div>

                {isMobile && (
                  <p
                    onClick={() => setReportErrorPopup(true)}
                    className="text-regular text-[#FA6B6B] cursor-pointer"
                  >
                    Report
                  </p>
                )}
              </div>
            </div>
          )}
          {clickedImg?.fileUrls?.map((obj, index) => {
            return (
              <>
                {contestDetails?.contestType !== "REVIEW" && (
                  <div
                    className={`${
                      index === 0 ? "h-[58vh]" : "h-[auto] mb-[20px]"
                    } w-[100%] flex items-center justify-center relative `}
                    style={{
                      background: `url(${
                        obj.fileType?.startsWith("video")
                          ? clickedImg?.thumbnailUrl
                          : obj.fileUrl
                      }) center center/cover no-repeat`,
                    }}
                  >
                    <div className={styles.imageBg}>
                      {isLoading &&
                        index == 0 &&
                        obj.fileType?.startsWith("image") && (
                          <div className="w-full h-full flex items-center justify-center">
                            <Lottie
                              loop
                              animationData={loadingAnimation}
                              play
                              style={{ width: 100, height: 100 }}
                            />
                          </div>
                        )}
                      {obj.fileType?.startsWith("video") && (
                        <ReactPlayer
                          config={{
                            file: {
                              attributes: { controlsList: "nodownload" },
                            },
                          }}
                          playing={false}
                          controls={true}
                          width="100%"
                          height="100%"
                          url={obj.fileUrl}
                        />
                      )}
                      {obj.fileType?.startsWith("image") && (
                        <img
                          src={obj.fileUrl}
                          alt=""
                          className={`h-[100%] w-[100%] mx-auto object-contain `}
                          onLoad={handleImageLoad}
                          style={{
                            display: isLoading ? "none" : "block",
                          }}
                        />
                      )}
                      {obj.fileType?.startsWith("audio") && (
                        <div className="h-full p-[20px] ">
                          <img
                            src={clickedImg?.thumbnailUrl}
                            className={`h-[80%] w-[100%] mx-auto object-contain mb-[10px]`}
                          />
                          <AudioPlayerWithoutDownload
                            fileUrl={obj?.fileUrl}
                            fileName="my voice recording"
                          />
                        </div>
                      )}
                      {index == 0 && (
                        <>
                          <button
                            className="w-[32px] h-[32px] disabled:opacity-0  absolute top-[45%] left-[9px]  backdrop-blur-[27px] rounded-full"
                            disabled={isPrevDisabled}
                            onClick={handelRotationLeft}
                          >
                            <img className="w-[32px] h-[32px]  " src={Left} />
                          </button>
                          <button
                            className="w-[32px] h-[32px] disabled:opacity-0  absolute  top-[45%] right-[9px] backdrop-blur-[27px] rounded-full"
                            onClick={handelRotationRight}
                            disabled={!guestModeEnabled && isNextDisabled}
                          >
                            <img
                              src={Right}
                              className="w-[32px] h-[32px] "
                              alt=""
                            />
                          </button>
                          {obj?.fileType?.startsWith("image") && (
                            <button
                              className="absolute bottom-[9px] right-[9px] w-[30px] h-[30px] flex items-center justify-center"
                              onClick={() => setShowFullScreen(true)}
                            >
                              <FullScreenIcon />
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                {index == 0 && (
                  <>
                    {contestDetails?.contestType == "REVIEW" && (
                      <div className="flex flex-col items-center justify-center gap-[10px] select-none z-[1] mt-[20px]">
                        <img
                          src={clickedImg?.thumbnailUrl}
                          alt=""
                          className="h-[60px] w-[60px] rounded-full overflow-hidden  object-cover"
                        />

                        <p className="text-regular">
                          {clickedImg?.participantName}
                        </p>
                      </div>
                    )}
                    <div className="flex  items-center justify-between py-[16px] px-[20px]">
                      <div className="flex gap-[10px] items-center">
                        <div>
                          <div
                            className="flex items-center gap-[2px] cursor-pointer"
                            onClick={() =>
                              !contestDetails?.likeClosed && loading
                                ? null
                                : LikeHandle()
                            }
                          >
                            {!contestDetails?.likeClosed && (
                              <div className="relative h-[36px] w-[36px] ">
                                {!loading && (
                                  <img
                                    className="h-[36px] w-[36px]"
                                    src={
                                      likeMap?.get("con" + clickedImg?._id)
                                        ?.liked
                                        ? Like
                                        : BlacLike
                                    }
                                    alt=""
                                  />
                                )}
                                {loading && (
                                  <div
                                    className={`pulsating-circle ${styles.like}`}
                                  />
                                )}
                              </div>
                            )}
                            <div className="flex flex-col">
                              <p
                                onClick={handleViewLike}
                                className={`whitespace-nowrap ${
                                  clickedImg?.uid == currentUser?.uid
                                    ? styles.clickable
                                    : ""
                                }`}
                              >
                                {
                                  likeMap?.get("con" + clickedImg?._id)
                                    ?.likesCount
                                }{" "}
                                Votes
                              </p>
                            </div>
                          </div>
                        </div>
                        {details?.certificate && (
                          <button
                            className="w-[60px] h-[30px]"
                            onClick={handleOpenCertificate}
                          >
                            <Certificate />
                          </button>
                        )}
                      </div>
                      <div
                        onClick={ShareHandle}
                        className="flex items-center  hover:cursor-pointer"
                      >
                        <img
                          src={shareButton}
                          alt=""
                          className="w-[36px] h-[36px]   z-[1]"
                        />
                        <p className="text-regular-medium">Share</p>
                      </div>
                    </div>
                    {contestDetails?.contestType == "REVIEW" && (
                      <>
                        <div className="px-[20px]">
                          <div className="seperator" />
                          <div
                            className={`mb-[20px] bg-[#0f0f0f] rounded-[10px] py-[16px] px-[10px] mt-[30px]`}
                          >
                            <pre className="text-regular text-[#f6f6f6]">
                              {clickedImg?.review}
                            </pre>
                          </div>
                        </div>
                      </>
                    )}
                    {clickedImg?.description && (
                      <div className="px-[20px]">
                        <div className="seperator" />
                      </div>
                    )}
                    {(clickedImg?.description ||
                      clickedImg?.fileUrls?.length > 1) &&
                      contestDetails?.contestType !== "REVIEW" && (
                        <div className="w-full flex items-center justify-center pt-[10px]">
                          <img src={ScrollDown} />
                        </div>
                      )}
                    <div className="p-[16px]">
                      {!_.isEmpty(clickedImg?.predictions) && (
                        <div>
                          <p
                            className="text-regular-medium mb-[12px]"
                            style={{
                              color: contestDetails?.buttonColor,
                            }}
                          >
                            Predictions
                          </p>
                          {clickedImg?.predictions?.map((obj) => {
                            const matchDetails =
                              contestDetails?.matchDetails?.find(
                                (el) => el?.id == obj?.id
                              );
                            const matchDate = new Date(matchDetails?.matchDate);
                            const formattedMatchDate = `${matchDate.toLocaleString(
                              "default",
                              {
                                month: "long",
                              }
                            )} ${matchDate.getUTCDate()} ${matchDate.getUTCFullYear()} , ${matchDate.toLocaleTimeString()}`;
                            return (
                              <div className="p-[15px] mb-[20px] rounded-[20px] bg-[#141414]">
                                <div className="flex items-center gap-[6px] pb-[16px] border-b-[1px] border-[#363636]">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.66137 2.649C8.69235 2.58558 8.74052 2.53214 8.80039 2.49476C8.86026 2.45738 8.92942 2.43756 9 2.43756C9.07058 2.43756 9.13974 2.45738 9.19961 2.49476C9.25947 2.53214 9.30764 2.58558 9.33862 2.649L11.1319 6.3C11.187 6.41175 11.2931 6.48938 11.4165 6.50738L15.4264 7.09275C15.7361 7.13812 15.8595 7.52062 15.6356 7.74L12.7339 10.5821C12.6899 10.625 12.657 10.678 12.638 10.7365C12.6191 10.795 12.6147 10.8572 12.6251 10.9178L13.3102 14.9303C13.3631 15.2404 13.0395 15.477 12.7624 15.3307L9.17587 13.4359C9.12171 13.4071 9.06132 13.3921 9 13.3921C8.93867 13.3921 8.87828 13.4071 8.82412 13.4359L5.23762 15.3307C4.9605 15.477 4.63687 15.2407 4.68975 14.9306L5.3745 10.9181C5.38503 10.8575 5.38063 10.7952 5.36168 10.7367C5.34273 10.6781 5.30981 10.6251 5.26575 10.5821L2.36475 7.74C2.1405 7.52062 2.26425 7.13812 2.574 7.09275L6.58425 6.50775C6.70725 6.48938 6.81337 6.41175 6.8685 6.3L8.66137 2.649Z"
                                      fill="#FFE100"
                                    />
                                  </svg>

                                  <p className="text-small-medium ">
                                    Match Day:{" "}
                                    {matchDate == "Invalid Date"
                                      ? matchDetails?.matchDate
                                      : formattedMatchDate}
                                  </p>
                                </div>

                                <div className=" w-full">
                                  <div className="my-[18px] flex w-[100%] gap-[17px] justify-evenly items-center">
                                    <div
                                      className={`flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ${
                                        obj?.winner == "team1" &&
                                        "border-[1px] border-[#FFA82833]"
                                      }`}
                                    >
                                      {obj?.winner == "team1" && (
                                        <img
                                          src={trophy}
                                          className="absolute top-[-10px] mx-auto"
                                        />
                                      )}
                                      <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
                                        <img
                                          src={matchDetails?.team1?.logo}
                                          alt=""
                                        />
                                      </div>
                                      <p className="text-white mt-[12px] text-center text-small-medium">
                                        {matchDetails?.team1?.name}
                                      </p>
                                    </div>
                                    <img src={vsIcon} className="" />

                                    <div
                                      className={`flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ${
                                        obj?.winner == "team2" &&
                                        "border-[1px] border-[#FFA82833]"
                                      }`}
                                    >
                                      {obj?.winner == "team2" && (
                                        <img
                                          src={trophy}
                                          className="absolute top-[-10px] mx-auto"
                                        />
                                      )}
                                      <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
                                        <img
                                          src={matchDetails?.team2?.logo}
                                          alt=""
                                        />
                                      </div>
                                      <p className="text-white mt-[12px] text-center text-small-medium">
                                        {matchDetails?.team2.name}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="flex w-full items-center gap-[16px] pt-[16px] border-t-[1px] border-[#363636]">
                                  <img src={prediction} className="h-[12px]" />

                                  <p className="text-small-medium">
                                    {matchDetails &&
                                      matchDetails[obj.prediction] &&
                                      matchDetails[obj.prediction].name}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      {clickedImg?.description && (
                        <div
                          className={`mb-[20px] bg-[#0f0f0f] rounded-[10px] py-[16px] px-[10px]`}
                        >
                          <pre className="text-regular text-[#f6f6f6]">
                            {clickedImg?.description}
                          </pre>
                        </div>
                      )}
                      {contestDetails?.formAttributes?.map((el) => {
                        return (
                          <div className="flex flex-col gap-[30px] px-[4px] ">
                            {el?.items?.map((key) => {
                              if (clickedImg[key] && el?.display) {
                                if (el.attrType == "media") {
                                  return (
                                    <div className="pb-[30px]">
                                      <p
                                        className="text-regular-medium mb-[12px]"
                                        style={{
                                          color: contestDetails?.buttonColor,
                                        }}
                                      >
                                        {el?.title}{" "}
                                      </p>
                                      {el?.type?.startsWith("image") && (
                                        <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                          <img
                                            src={clickedImg[key]}
                                            className="w-auto h-[100%]"
                                          />
                                        </div>
                                      )}
                                      {el?.type?.startsWith("video") && (
                                        <div className="h-[320px] w-[100%] overflow-hidden flex items-center justify-center mb-[15px] bg-[#1c1c1c]">
                                          <ReactPlayer
                                            playing={false}
                                            controls={true}
                                            width="100%"
                                            height="100%"
                                            url={clickedImg[key]}
                                            style={{ objectFit: "contain" }}
                                            playsinline
                                          />
                                        </div>
                                      )}
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div className="pb-[30px]">
                                      <p
                                        className="text-regular-medium mb-[12px]"
                                        style={{
                                          color: contestDetails?.buttonColor,
                                        }}
                                      >
                                        {el?.title}{" "}
                                      </p>
                                      <p className="text-regular-callout  text-[#606060]">
                                        {clickedImg[key]}
                                      </p>
                                    </div>
                                  );
                                }
                              }
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </>
            );
          })}
          <div className="px-[20px] mt-[40px] ">
            <div className="seperator " />
          </div>
          <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
        </div>
        {share && (
          <SharePopup showShare={ShareHandle} contestant={clickedImg} />
        )}

        {showFullScreen && (
          <FullScreenViewer
            setShowPopup={setShowFullScreen}
            items={clickedImg?.fileUrls}
            index={0}
            heading={clickedImg?.participantName}
            color={contestDetails?.buttonColor}
          />
        )}
        {likePopup && (
          <LikePopup
            setPopup={setLikePopup}
            backgroundColor={contestDetails?.buttonColor}
            message={likeMessage}
          />
        )}
      </div>
    </>
  );
};

export default EntryDetailPage;
